class PlanSelector {
  
  selected_plan=null;
  selected_variant=null;
  plan_duration=null;
  plan_type=null;

  constructor() {
    var query_string = window.location.href.toLowerCase().split("#")[1];
    if (!query_string) {
      this.selected_plan = window.plan_details_private.find(plan => plan.handle == window.first_selected_plan && plan.duration == window.plan_days && plan.type == window.plan_meals && plan.extra == window.plan_snacks);
    } else {
      var plan_requested = query_string.split("&")[0];
      this.selected_plan = window.plan_details_private.find(plan => plan.handle == plan_requested && plan.duration == window.plan_days && plan.type == window.plan_meals && plan.extra == window.plan_snacks);
    }
    if (!this.selected_plan) {
      this.selected_plan = window.plan_details_private[0];
    }
    this.selected_variant = this.selected_plan.id;
    this.plan_duration  = this.selected_plan.duration;
    this.plan_type  = this.selected_plan.type;
    this.plan_snacks = this.selected_plan.snack_count;
    this.setupEvents();
    this.render();
  }
  setupEvents() {
    document.querySelectorAll(".single-plan-product").forEach(prog=>{
      prog.addEventListener("click",()=>{
        this.select_program(parseInt(prog.getAttribute("data-product-id")));
        var url = "#" + prog.getAttribute("data-handle");
        window.history.pushState({}, '', url);
      });
    });

    $('.coupon-field input').each(function () {
      if ($(this).hasClass('required')) {
        $(this).nextAll('.error-empty').show();
      }

      $(this).focus(function () {
        $(this).removeClass('untouched');
      });

      $(this).blur(function () {
        if ($(this).hasClass('required')) {
          if ($(this).val() == "") {
            $(this).nextAll('.error-empty').show();
            $(this).nextAll('.error-invalid').hide();
            $(this).addClass('invalid');
          } else {
            $(this).nextAll('.error-empty').hide();

            if ($(this).data('validation') != "") {
              validateInput($(this));
            } else {
              $(this).nextAll('.error').hide();
              $(this).removeClass('invalid');
            }
          }
        } else if ($(this).data('validation') != "") {
          validateInput($(this));
        }
      });

      $(this).keyup(function () {
        if ($(this).hasClass('required')) {
          if ($(this).val() == "") {
            $(this).nextAll('.error-empty').show();
            $(this).nextAll('.error-invalid').hide();
            $(this).addClass('invalid');
          } else {
            $(this).nextAll('.error-empty').hide();

            if ($(this).data('validation') != "") {
              validateInput($(this));
            } else {
              $(this).nextAll('.error').hide();
              $(this).removeClass('invalid');
            }
          }
        } else if ($(this).data('validation') != "") {
          validateInput($(this));
        }
        
        if ($('input.invalid').length || $('input.untouched').length) {
          $('#select-plan-btn').attr('disabled', '');
        } else {
          $('#select-plan-btn').removeAttr('disabled');
        }

        if ($(this).is('#coupon-code')) {
          const couponCode = $(this).val();
          if (window.shipping_discount_code) {
            document.getElementById('returnToField').value = "/checkout?discount=" + couponCode + "," + window.shipping_discount_code;
          } else {
            document.getElementById('returnToField').value = "/checkout?discount=" + couponCode;
          }
        }
      });
    });

    function validateInput(el) {
      const dataRegEx = new RegExp($(el).data('validation'), $(el).data('flags'));
      const value = $(el).val();

      if (dataRegEx.test(value)) {
        $(el).nextAll('.error-invalid').hide();
        $(el).removeClass('invalid');
      } else {
        $(el).nextAll('.error-invalid').show();
        $(el).addClass('invalid');
      }
    }
    
    if (!window.snack_upsell_disabled && this.selected_plan.handle != 'vegan-program') {
      document.querySelectorAll(".variant-option[name='snacks']").forEach(input=>{
        input.addEventListener("click",async event=>{
          event.preventDefault();
          document.getElementById('decline-snacks-btn').classList.add('button--loading');

          this.update_snacks(event.target.value);

          let addToCartForm = document.querySelector("form[action$='/cart/add']");
          let formData = new FormData(addToCartForm);

          await this.clear_cart();
          await this.add_to_cart(formData);

          const returnToUrl = formData.get("return_to") || "/checkout";
          window.location.href = returnToUrl;
        });
      });
    }
    
    document.getElementById('select-plan-btn').addEventListener("click", async event => {
      event.preventDefault();
      if (window.snack_upsell_disabled || this.selected_plan.handle == 'vegan-program') {
        event.currentTarget.classList.add('button--loading');

        let addToCartForm = document.querySelector("form[action$='/cart/add']");
        let formData = new FormData(addToCartForm);

        await this.clear_cart();
        await this.add_to_cart(formData);

        const returnToUrl = formData.get("return_to") || "/checkout";
        window.location.href = returnToUrl;
      } else {
        document.querySelectorAll('.js-plan-step').forEach(el => {
          el.classList.remove('active');
        });
        document.querySelectorAll('.js-snack-step').forEach(el => {
          el.classList.add('active');
        });
        document.getElementById('order-anchor').scrollIntoView();
      }
    });

    if (!window.snack_upsell_disabled && this.selected_plan.handle != 'vegan-program') {
      document.getElementById('decline-snacks-btn').addEventListener("click", async event => {
        event.preventDefault();
        event.currentTarget.classList.add('button--loading');

        let addToCartForm = document.querySelector("form[action$='/cart/add']");
        let formData = new FormData(addToCartForm);

        await this.clear_cart();
        await this.add_to_cart(formData);

        const returnToUrl = formData.get("return_to") || "/checkout";
        window.location.href = returnToUrl;
      });

      document.getElementById('back-to-plan-btn').addEventListener("click", () => {
        document.querySelectorAll('.js-plan-step').forEach(el => {
          el.classList.add('active');
        });
        document.querySelectorAll('.js-snack-step').forEach(el => {
          el.classList.remove('active');
        });
        document.getElementById('order-anchor').scrollIntoView();
      });
    }
  }
  render() {
    document.querySelectorAll(".single-plan-product").forEach(prog=>{
      if (prog.getAttribute("data-product-id")==this.selected_plan.plan_id) {
        prog.setAttribute("checked","")
        prog.classList.add("checked");
        document.querySelector(".js-prod-description").innerHTML = prog.getAttribute("data-description");
      } else {
        prog.removeAttribute("checked");
        prog.classList.remove("checked");
      }
    });

    console.log(this);

    if (!window.snack_upsell_disabled && this.selected_plan.handle != 'vegan-program') {
      let snack2Plan = window.plan_details_private.find(plan => plan.plan_id == this.selected_plan.plan_id && plan.meals == "LD" && plan.duration == window.plan_days && plan.snack_count == 2);
      let snack2Price = snack2Plan?.compare_at - this.selected_plan.compare_at;

      let snack3Plan = window.plan_details_private.find(plan => plan.plan_id == this.selected_plan.plan_id && plan.meals == "LD" && plan.duration == window.plan_days && plan.snack_count == 3);
      let snack3Price = snack3Plan?.compare_at - this.selected_plan.compare_at;

      if (this.plan_snacks == 0) {
        document.querySelector(".js-snack-price-2").innerHTML = snack2Price.toFixed(2);
        document.querySelector(".js-snack-price-3").innerHTML = snack3Price.toFixed(2);
      }
    }

    document.querySelector(".js-variant-id").value=this.selected_plan.id;
    document.querySelector("input#selling_plan").value = this.selected_plan.selling_plan_id;
  }

  select_program(id) {
    let is_vegan = window.plan_details_private.some(p => p.plan_id == id && p.handle == 'vegan-program');
    this.plan_type = is_vegan && this.plan_type == 'Full Program' ? 'Lunches & Dinners' : this.plan_type;

    this.selected_plan = window.plan_details_private.find(program=>{
      return program.plan_id == id 
        && program.type == this.plan_type 
        && program.duration == this.plan_duration 
        && program.snack_count == this.plan_snacks
    });
    this.selected_variant = this.selected_plan.id;
    this.render();
  }
  update_snacks(d) {
    this.plan_snacks = d;
    this.select_program(this.selected_plan.plan_id);
  }
  async clear_cart() {
    try {
      await fetch(window.Shopify.routes.root + 'cart/clear.js', {
        method: 'POST'
      });
      // Clear cart attributes (set each attribute value to null)
      const response = await fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
      });
      const cart = await response.json();
      let newAttributes = Object.keys(cart.attributes).reduce((newAttr, key) => {
        newAttr[key] = null;
        return newAttr;
      }, {});
      const result = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes: newAttributes })
      });
      return result.json();
    }
    catch(error) {
      console.error('Error:', error);
    }
  }
  async add_to_cart(formData) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      return response.json();
    }
    catch(error) {
      console.error('Error:', error);
    }
  }
  
}
window.addEventListener("DOMContentLoaded",event=>{
	const selector = new PlanSelector();
});
